var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSubscribe(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 294,
    height: 257,
    viewBox: "0 0 294 257",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M218.198 128.5C263.671 103.257 293.986 55.5286 293.986 0H257.236C257.236 61.0286 208.088 110.143 146.986 110.143C85.8835 110.143 36.7357 61.0429 36.7357 0H0C0 55.5286 30.3152 103.257 75.7879 128.5C30.3152 153.743 0 201.471 0 257H36.75C36.75 195.971 85.8978 146.857 147 146.857C208.102 146.857 257.25 195.957 257.25 257H294C294 201.471 263.685 153.743 218.212 128.5",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSubscribe);
export default __webpack_public_path__ + "static/media/subscribe.9ad88a99575ea299d04d21bfce936b81.svg";
export { ForwardRef as ReactComponent };